import { ChangeEvent, FunctionComponent, useCallback, useState } from 'react'
import { MdPlayArrow } from 'react-icons/md'
import { StyledError } from 'shared/components/Input/styles'

import * as Yup from 'yup'

import iconConj from 'shared/assets/icons/icon-conj.svg'
import Form, { IProps as FormProps } from 'shared/components/Form'
import Input from 'shared/components/Input'
import Page from 'shared/components/Page'
import { colors } from 'shared/styles/colors'
import { cnpjMask, normalizeCnpj } from 'shared/utils/formatters'

import { steps } from '../../'
import { ICnpjProps } from './CnpjComponent.types'
import { ContainerForm, StyledButton } from './styles'

const Cnpj: FunctionComponent<ICnpjProps> = ({
  setSelectedStep,
  validateCnpj,
}) => {
  const [cnpj] = useState(() => {
    if (localStorage.getItem('@TMov:SignUpCnpj')) {
      return localStorage.getItem('@TMov:SignUpCnpj')
    }

    return ''
  })
  const [cnpjOk, setCnpjOk] = useState(() => {
    if (localStorage.getItem('@TMov:SignUpCnpj')) {
      return true
    }

    return false
  })
  const [errorMessage, setErrorMessage] = useState('')

  const handleSubmit = useCallback(
    async (values: FormProps['values']) => {
      try {
        const normalizedCnpj = normalizeCnpj(values.cnpj)
        const params = {
          type: 'cnpj',
          cnpj: normalizedCnpj,
        }
        await validateCnpj.execute(params)

        localStorage.setItem('@TMov:SignUpCnpj', normalizedCnpj)
        setSelectedStep(steps.Photo)
      } catch (error: unknown) {
        if (error instanceof Error) {
          setErrorMessage(error.message)
        } else {
          setErrorMessage('Erro ao tentar submeter o formulario')
        }
      }
    },
    [setSelectedStep, validateCnpj],
  )

  const handleChange = useCallback(async (e: ChangeEvent<HTMLInputElement>) => {
    setErrorMessage('')
    setCnpjOk(false)

    if (!e.target.value) return

    try {
      await Yup.string()
        .required()
        .length(14)
        .validate(normalizeCnpj(e.target.value), {
          abortEarly: false,
        })

      setCnpjOk(true)
    } catch (e) {
      setCnpjOk(false)
    }
  }, [])

  return (
    <Page
      title="Beleza! Agora nos informe o CNPJ da sua empresa:"
      icon={iconConj}
      goBackTo={() => {
        setSelectedStep(steps.Phone)
      }}
    >
      <Form
        onSubmit={handleSubmit}
        initialValues={{ cnpj }}
        validationSchema={() => ({
          cnpj: Yup.string().required(),
        })}
      >
        {formControl => (
          <ContainerForm>
            <Input
              placeholder="Digite o CNPJ"
              name="cnpj"
              formControl={formControl}
              errorMessage={''}
              onChange={handleChange}
              mask={value => cnpjMask(value)}
              maxLength={18}
            />
            <div>
              {errorMessage ? <StyledError>{errorMessage}</StyledError> : <></>}
            </div>

            <StyledButton
              placeholder="Proximo"
              color={cnpjOk ? colors.green : colors.grayLight}
              disabled={!cnpjOk}
              type="submit"
              onClick={formControl.handleSubmit}
            >
              <MdPlayArrow /> Proximo
            </StyledButton>
          </ContainerForm>
        )}
      </Form>
    </Page>
  )
}

export default Cnpj
